import { render, staticRenderFns } from "./StockOutStatsCard.vue?vue&type=template&id=757c7db8"
import script from "./StockOutStatsCard.vue?vue&type=script&lang=js"
export * from "./StockOutStatsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports